import { render } from "./bmTopicInfo.vue?vue&type=template&id=3f02612f&scoped=true"
import script from "./bmTopicInfo.vue?vue&type=script&lang=js"
export * from "./bmTopicInfo.vue?vue&type=script&lang=js"

import "./bmTopicInfo.vue?vue&type=style&index=0&id=3f02612f&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f02612f"]])

export default __exports__